import React from 'react';
import { ui } from 'util/ui';
import ArchyModal from 'components/shell/ArchyModal';
import { Spinner } from 'components/spinner';

/** Shown while a file moves to another project. No close: the move must finish. */
const MovingModal = () => (
  <ArchyModal width={360}>
    <div style={{ padding: '28px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, textAlign: 'center' }}>
      <Spinner altStyle />
      <div>
        <div style={{ fontSize: 16, fontWeight: 700, color: ui.ink }}>Moving the file…</div>
        <div style={{ marginTop: 4, fontSize: 13, color: ui.muted }}>Please keep this page open until it finishes.</div>
      </div>
    </div>
  </ArchyModal>
);

export default MovingModal;
